import { ApiRoutes } from "@futgg/core";
var JS_SELECTOR = "#homepage-runway";
var JS_CONTAINER_SELECTOR = ".homepage-runway__container";
var JS_BOX_SELECTOR = ".homepage-runway__box";
var JS_LOADING_SELECTOR = ".homepage-runway__loading";
var SCROLL_BODY_OFFSET = 10;
var loading = false;
function loadNewContent(homepageRunwayEl, dayId) {
    if (dayId === void 0) { dayId = null; }
    loading = true;
    var loadingEl = homepageRunwayEl.querySelector(JS_LOADING_SELECTOR);
    if (loadingEl) {
        loadingEl.classList.remove('hidden');
    }
    var maxDayId;
    if (dayId === null) {
        maxDayId = Math.max.apply(Math, Array.from(homepageRunwayEl.querySelectorAll(JS_BOX_SELECTOR)).map(function (el) { return parseInt(el.dataset.runwayDayId || '0', 10); }));
    }
    else {
        maxDayId = dayId;
    }
    fetch(ApiRoutes.getHomepageScrollerData(maxDayId))
        .then(function (response) { return response.json(); })
        .then(function (data) {
        var containerEl = homepageRunwayEl.querySelector(JS_CONTAINER_SELECTOR);
        if (containerEl) {
            var div = document.createElement('div');
            containerEl.appendChild(div);
            var contentDiv = document.createElement('div');
            contentDiv.innerHTML = data.html;
            containerEl.appendChild(contentDiv);
            window.futggLazyRootInit(div, contentDiv);
            // (window as any).playerTooltipInit(contentDiv);
        }
    })
        .finally(function () {
        loading = false;
        if (loadingEl) {
            loadingEl.classList.add('hidden');
        }
    });
}
function startScroller(homepageRunwayEl) {
    window.addEventListener('scroll', function () {
        if (window.scrollY + window.innerHeight >= document.body.offsetHeight - SCROLL_BODY_OFFSET &&
            !loading) {
            loadNewContent(homepageRunwayEl);
        }
    });
}
export function homepageScrollerInit() {
    var homepageRunwayEl = document.querySelector(JS_SELECTOR);
    if (homepageRunwayEl) {
        loadNewContent(homepageRunwayEl, 0);
        startScroller(homepageRunwayEl);
    }
}
